/** Remove inert from header nav dropdowns on desktop (ADA). Mobile inert is synced in navigation.ts via clickMenu events. */
const siteHeader = document.getElementById('site-header');
if (siteHeader) {
  const inertMenus = [...siteHeader.querySelectorAll('[data-menu-drop]')];
  const mediaQuery = window.matchMedia('(min-width: 60em)');

  const handleScreenResize = (event: MediaQueryList | MediaQueryListEvent): void => {
    if (event.matches) {
      inertMenus.forEach((inertMenu) => {
        inertMenu.removeAttribute('inert');
      });
    }
  };

  if (inertMenus.length !== 0) {
    handleScreenResize(mediaQuery);
    mediaQuery.addEventListener('change', handleScreenResize);
  }
}
